import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { DateFormat, UpdateOrganizationInput } from "@repo/shared";
import {
  updateOrganization,
  updateOrganizationDateFormat,
  deleteOrganization,
} from "@/lib/api/organizations";
import { connectionKeys } from "@/features/qlik-connections/api";

// Re-export the query options that already exist on the connectionKeys factory
// so organization feature code can use a single import
export { organizationMembershipsQueryOptions } from "@/features/qlik-connections/api";

export const organizationKeys = {
  all: ["organizations"] as const,
};

export function useUpdateOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      organizationId,
      data,
    }: {
      organizationId: string;
      data: UpdateOrganizationInput;
    }) => updateOrganization(organizationId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: connectionKeys.organizations() });
    },
  });
}

export function useUpdateOrganizationDateFormat() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dateFormat: DateFormat) => updateOrganizationDateFormat(dateFormat),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: connectionKeys.organizations() });
    },
  });
}

export function useDeleteOrganization() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (organizationId: string) => deleteOrganization(organizationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: connectionKeys.organizations() });
    },
  });
}
